import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Row, Col, Divider } from 'antd';

// Urutan field mengikuti payload response (detil lalu header)
const HEADER_FIELDS = [
    { name: 'callSign', label: 'Call Sign' },
    { name: 'kodeDokumen', label: 'Kode Dokumen' },
    { name: 'kodeGudang', label: 'Kode Gudang' },
    { name: 'kodeSaranaAngkutInOut', label: 'Kd Sar Angkut Inout' },
    { name: 'kodeTps', label: 'Kode TPS' },
    { name: 'namaAngkut', label: 'Nama Angkut' },
    { name: 'nomorBc11', label: 'No BC11' },
    { name: 'nomorPosBc11', label: 'No Pos BC11' },
    { name: 'nomorVoyFlight', label: 'No Voy Flight' },
    { name: 'refNumber', label: 'Ref Number' },
    { name: 'tanggalBc11', label: 'Tgl BC11' },
    { name: 'tanggalBerangkat', label: 'Tgl Berangkat' },
    { name: 'tanggalPerkiraanBerangkat', label: 'Tgl Perkiraan Berangkat' },
    { name: 'tanggalTiba', label: 'Tanggal Tiba' },
];

const DETIL_FIELDS = [
    { name: 'bruto', label: 'Bruto' },
    { name: 'consignee', label: 'Consignee' },
    { name: 'gudangTujuan', label: 'Gudang Tujuan' },
    { name: 'idConsignee', label: 'ID Consignee' },
    { name: 'jumlahKemasan', label: 'Jumlah Kemas' },
    { name: 'kodeDokumenInOut', label: 'Kode Dok Inout' },
    { name: 'kodeKantor', label: 'Kode Kantor' },
    { name: 'kodeKemasan', label: 'Kode Kemas' },
    { name: 'kodeSaranaAngkutInOut', label: 'Kd Sar Angkut Inout' },
    { name: 'kodeTimbun', label: 'Kode Timbun' },
    { name: 'kontainerAsal', label: 'Kontainer Asal' },
    { name: 'nomorBc11', label: 'No BC11' },
    { name: 'nomorBlAwb', label: 'No BL AWB' },
    { name: 'nomorDaftarPabean', label: 'No Daftar Pabean' },
    { name: 'nomorDokumenInOut', label: 'No Dok Inout' },
    { name: 'nomorIjinTps', label: 'No Ijin TPS' },
    { name: 'nomorMasterBlAwb', label: 'No Master BL AWB' },
    { name: 'nomorPolisi', label: 'No Polisi' },
    { name: 'nomorPosBc11', label: 'No Pos BC11' },
    { name: 'nomorSegelBc', label: 'No Segel BC' },
    { name: 'pelabuhanBongkar', label: 'Pel Bongkar' },
    { name: 'pelabuhanMuat', label: 'Pel Muat' },
    { name: 'pelabuhanTransit', label: 'Pel Transit' },
    { name: 'seriKemasan', label: 'Seri Kemas' },
    { name: 'tanggalBc11', label: 'Tgl BC11' },
    { name: 'tanggalBlAwb', label: 'Tgl BL AWB' },
    { name: 'tanggalDaftarPabean', label: 'Tgl Daftar Pabean' },
    { name: 'tanggalDokumenInOut', label: 'Tgl Dok Inout' },
    { name: 'tanggalIjinTps', label: 'Tgl Ijin TPS' },
    { name: 'tanggalMasterBlAwb', label: 'Tgl Master BL AWB' },
    { name: 'tanggalSegelBc', label: 'Tgl Segel BC' },
    { name: 'waktuInOut', label: 'Waktu Inout' },
];

const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
};

// Susun ulang key sesuai urutan FIELD agar body POST sama persis seperti response.
// Field tak dikenal (di luar daftar) disertakan di belakang agar tidak hilang.
const orderRow = (row, fields) => {
    const out = {};
    fields.forEach((f) => { out[f.name] = row?.[f.name] ?? ''; });
    Object.keys(row || {}).forEach((k) => { if (!(k in out)) out[k] = row[k]; });
    return out;
};

export default ({ visible, data, onCancel, onSend }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && data) {
            form.setFieldsValue(data);
        }
    }, [visible, data, form]);

    const handleSend = () => {
        form.validateFields()
            .then((values) => onSend({
                header: orderRow(values.header, HEADER_FIELDS),
                detil: (values.detil || []).map((r) => orderRow(r, DETIL_FIELDS)),
            }))
            .catch((info) => console.log('Validate Failed:', info));
    };

    return (
        <Modal
            title="Kirim Ulang (JSON)"
            visible={visible}
            onCancel={onCancel}
            onOk={handleSend}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleSend}>
                    Send
                </Button>,
            ]}
            width="70%"
            destroyOnClose={false}
        >
            <Form layout="vertical" form={form} initialValues={data} preserve={false}>
                <Divider plain>HEADER</Divider>
                {chunk(HEADER_FIELDS, 4).map((row, ri) => (
                    <Row gutter={16} key={ri}>
                        {row.map((f) => (
                            <Col span={6} key={f.name}>
                                <Form.Item label={f.label} name={['header', f.name]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                        ))}
                    </Row>
                ))}

                <Divider plain>DETIL</Divider>
                {chunk(DETIL_FIELDS, 4).map((row, ri) => (
                    <Row gutter={16} key={ri}>
                        {row.map((f) => (
                            <Col span={6} key={f.name}>
                                <Form.Item label={f.label} name={['detil', 0, f.name]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                        ))}
                    </Row>
                ))}
            </Form>
        </Modal>
    );
};
